import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const ModalDuplicados = ({
  mostrar,
  clientes,
  mensaje,
  onSeleccionar,
  onConfirmarNuevo,
  guardando,
  getEstiloSimilitud,
}) => {
  if (!mostrar) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="text-lg font-bold text-gray-800">Clientes Similares</h3>
          <button
            type="button"
            disabled={guardando}
            onClick={() => {}}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm text-gray-600 mb-4">{mensaje}</p>

          <div className="space-y-2 max-h-64 overflow-y-auto">
            {clientes.map((cliente) => (
              <button
                key={cliente.id}
                type="button"
                disabled={guardando}
                onClick={() => onSeleccionar(cliente)}
                className="w-full text-left p-3 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed transition"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <p className="font-medium text-gray-800">
                      {cliente.nombre} {cliente.apellido}
                    </p>
                    <p className="text-xs text-gray-500">{cliente.telefono}</p>
                  </div>
                  <div className="text-right">
                    <span className={`inline-block text-xs font-semibold px-2 py-1 rounded ${getEstiloSimilitud(cliente.similitud)}`}>
                      {Math.round(cliente.similitud * 100)}% similar
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>

          <div className="mt-4 pt-4 border-t">
            <button
              type="button"
              disabled={guardando}
              onClick={onConfirmarNuevo}
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm transition"
            >
              Crear cliente nuevo
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDuplicados;
